import { Action, isType } from 'ts-action'

import { IBaseReducer } from 'models/BaseReducer'
import { IFavorite } from 'models/Favorite'
import {
  ClearFavoredBusinessesReducer,
  FavoredBusinessesFetching,
  GetFavoredBusinesses,
  GetFavoredBusinessesErrors,
  FavoredBusinessesUnfavoriteBusiness,
} from 'data/upshifter/FavoredBusinesses/actions'

export interface IFavoredBusinessesReducer extends IBaseReducer<IFavorite[]> {
  hasMore: boolean
}

const initialState: IFavoredBusinessesReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const favoredBusinessesReducer = (
  state = initialState,
  action: Action,
) => {
  if (isType(action, GetFavoredBusinesses)) {
    const { data, meta } = action.payload
    return {
      ...state,
      meta: meta,
      data: data,
      error: undefined,
    }
  }
  if (isType(action, GetFavoredBusinessesErrors)) {
    const { payload } = action
    return {
      ...state,
      error: payload,
    }
  }
  if (isType(action, FavoredBusinessesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, ClearFavoredBusinessesReducer)) {
    return initialState
  }
  if (isType(action, FavoredBusinessesUnfavoriteBusiness)) {
    const { payload } = action
    const { data } = state
    const filteredArray = data.filter(
      ({ favored_business }) => favored_business?.id !== payload,
    )
    return {
      ...state,
      data: [...filteredArray],
      isFetching: false,
    }
  }

  return state
}
